<template>
  <div class="invoiceCenter" :class="{ 'invoiceCenter--embedded': embedded }">
    <div class="content">
      <div class="filterBar">
        <div v-if="$auth.isSuperAdmin()" class="filterSearch">
          <van-search
              v-model="query.userName"
              :placeholder="$t('recharge_center.filter_by_username')"
              shape="round"
              @search="reload"
              @clear="reload"
          />
        </div>
        <div class="statusQueryBar" @click="showStatusSheet = true">
          <div class="typeMenuTrigger">
            <span class="typeMenuText">{{ statusLabel }}</span>
            <van-icon name="arrow-down" class="typeMenuIcon" />
          </div>
        </div>
      </div>
      <div class="summaryBar">
        <span class="summaryItem">{{ $t('recharge_center.invoiced_amount') }}：<span class="summaryValue">¥{{ invoicedAmount }}</span></span>
        <span class="summaryItem">{{ $t('recharge_center.current_count') }}：<span class="summaryValue">{{ total }}</span></span>
      </div>
      <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('append_field.noMore')"
          @load="onLoad"
      >
        <div v-for="item in list" :key="item.id || item.orderNo" class="invoiceCard">
          <div class="row"><span class="k">{{ $t('recharge_center.invoice_title') }}</span><span class="v">{{ item.invoiceTitle || '-' }}</span></div>
          <div class="row"><span class="k">{{ $t('recharge_center.invoice_type') }}</span><span class="v">{{ item.invoiceTypeText || '-' }}</span></div>
          <div class="row"><span class="k">{{ $t('recharge_center.amount') }}</span><span class="v price">¥{{ item.amountYuan }}</span></div>
          <div class="row"><span class="k">{{ $t('recharge_center.status') }}</span><span class="v">{{ item.statusText }}</span></div>
          <div class="row"><span class="k">{{ $t('recharge_center.billing_time') }}</span><span class="v">{{ item.createTime || '-' }}</span></div>
          <div class="actions">
            <van-button size="small" v-if="item.fileUrl"  @click="viewInvoice(item)">{{ $t('recharge_center.view') }}</van-button>
            <van-button size="small" v-if="item.fileUrl "   type="primary" color="#006EFF" @click="downloadInvoice(item)">{{ $t('append_field.download') }}</van-button>
          </div>
        </div>
      </van-list>
    </div>

    <van-empty
      v-if="!loading && list.length === 0"
      image="/static/images/terminal/empty-img.png"
      :description="$t('recharge_center.no_invoice_record')"
    />

    <van-action-sheet
      v-model="showStatusSheet"
      :actions="statusActions"
      :cancel-text="$t('append_field.cancel')"
      close-on-click-action
      @select="onStatusSelect"
    />
  </div>
</template>

<script>
import qs from 'qs'
import { Toast } from 'vant'
import $auth from "@/utils/auth";

export default {
  name: 'InvoiceCenter',
  props: {
    /** 嵌在充值中心等页内 Tab 时，父级无整页高度链，需取消 100% 高度避免内容区高度为 0 */
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    $auth() {
      return $auth
    },
    statusOptions() {
      return [
        { text: this.$t('append_field.all'), value: '' },
        { text: this.$t('recharge_center.pending_invoice'), value: 0 },
        { text: this.$t('recharge_center.invoiced'), value: 1 },
        { text: this.$t('recharge_center.voided'), value: 2 },
      ]
    },
    statusLabel() {
      const cur = this.query.status
      const opt = this.statusOptions.find((o) => {
        if (o.value === cur) return true
        if (o.value === '' && (cur === '' || cur == null)) return true
        if (typeof o.value === 'number' && Number(cur) === o.value) return true
        return false
      })
      return opt ? opt.text : this.$t('append_field.all')
    },
    statusActions() {
      return this.statusOptions.map((o) => ({
        name: o.text,
        value: o.value,
      }))
    },
  },
  data() {
    return {
      showStatusSheet: false,
      query: {
        status: '',
        userName: '',
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      invoicedAmount: '0.00',
      list: [],
      loading: false,
      fetching: false,
      finished: false,
      finishedText: '',
    }
  },

  methods: {
    onStatusSelect(action) {
      if (!action || !Object.prototype.hasOwnProperty.call(action, 'value')) return
      const v = action.value
      this.query.status = typeof v === 'string' && v !== '' && /^\d+$/.test(v) ? Number(v) : v
      this.reload()
    },
    parseInvoiceInfo(raw) {
      if (!raw) return {}
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw)
      } catch (e) {
        return {}
      }
    },
    getInvoiceTypeText(v) {
      const n = Number(v)
      if (n === 1) return this.$t('recharge_center.vat_invoice')
      return this.$t('recharge_center.ordinary_invoice')
    },
    back() {
      this.$router.back()
    },
    reload() {
      this.pageNo = 1
      this.total = 0

      this.list = []
      this.finished = false
      this.finishedText = ''
      this.onLoad()
    },
    onLoad() {
      this.fetchInvoiceList()
    },
    async fetchInvoiceList() {
      if (this.fetching || this.finished) {
        this.loading = false
        return
      }
      this.fetching = true
      this.loading = true
      try {
        const res = await this.$ajax.post(
          '/etv/selectPageInvoiceRecord.json',
          qs.stringify({
            status: this.query.status,
            userName: this.query.userName,
            pageSize: this.pageSize,
            pageNo: this.pageNo,
          })
        )
        if (res && res.data && res.data.code === 0) {
          const data = res.data.data || {}
          this.invoicedAmount = Number(data.invoicedAmount/100 || 0).toFixed(2)
          const pageList = Array.isArray(data.list) ? data.list : []
          const mapped = pageList.map((it) => ({
            ...(it || {}),
            amountYuan: Number(it.amount/100 || 0).toFixed(2),
            statusText: Number(it.status) === 1
              ? this.$t('recharge_center.invoiced')
              : Number(it.status) === 0
                ? this.$t('recharge_center.pending_invoice')
                : this.$t('recharge_center.voided'),
            invoiceTypeText: this.getInvoiceTypeText(it.invoiceType),
            invoiceTitle: this.parseInvoiceInfo(it.invoiceInfo).invoiceTitle ||'',


          }))
          this.list = this.list.concat(mapped)

          this.total = Number(data.total || 0)
          const serverPage = Number(data.pageNum)
          if ((this.total > 0 && this.list.length >= this.total) || mapped.length === 0) {
            this.finished = true
            this.finishedText = this.$t('append_field.noMore')
          } else {
            this.pageNo = serverPage + 1
          }
          // total 未返回时兜底
          if (this.total === 0 && mapped.length < this.pageSize) {
            this.finished = true
            this.finishedText = this.$t('append_field.noMore')
          }
        } else {
          this.finished = true
          this.finishedText = this.finished ? this.$t('append_field.noMore') : ''
        }
      } catch (e) {
        this.finished = true
        this.finishedText = this.$t('append_field.noMore')
      } finally {
        this.fetching = false
        this.loading = false
      }
    },
    resolveFileUrl(item) {
      return item.fileUrl || ''
    },
    viewInvoice(item) {
      const url = this.resolveFileUrl(item)
      if (!url) {
        Toast(this.$t('recharge_center.no_viewable_file'))
        return
      }
      window.open(url, '_blank')
    },
    downloadInvoice(item) {
      const url = this.resolveFileUrl(item)
      if (!url) {
        Toast(this.$t('recharge_center.no_downloadable_file'))
        return
      }
      const a = document.createElement('a')
      a.href = url
      a.download = `invoice-${item.orderNo || 'file'}`
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
  },
}
</script>

<style lang="scss">
.invoiceCenter {
  height: 100% !important;
  overflow: hidden;

  &.invoiceCenter--embedded {
    height: auto !important;
    min-height: 200px;
    overflow: visible;

    .content {
      height: auto !important;
      max-height: none;
      overflow-y: visible;
      padding-bottom: 24px;
    }
  }

  .content {
    height: calc(100% - 56px);
    overflow-y: auto;
    padding-bottom: 70px;
  }
  .filterBar {
    display: flex;
    align-items: center;
    gap: 8px;

    .filterSearch {
      flex: 1;
      min-width: 0;

      .van-search {
        padding: 0;
      }
    }

    .statusQueryBar {
      flex-shrink: 0;

      &:only-child {
        flex: 1;
        min-width: 0;

        .typeMenuTrigger {
          max-width: none;
        }
      }

      .typeMenuTrigger {
        height: 36px;
        padding: 0 10px 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        background: #f7f8fa;
        border-radius: 8px;
        min-width: 72px;
        max-width: 120px;
        box-sizing: border-box;
      }

      .typeMenuText {
        font-size: 13px;
        color: #323233;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .typeMenuIcon {
        flex-shrink: 0;
        font-size: 14px;
        color: #969799;
      }
    }
  }
  .summaryBar {

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .summaryItem {
    color: #666;
    font-size: 14px;
  }
  .summaryValue {
    color: #111;
    font-weight: 600;
  }
  .invoiceCard {
    border: 1px solid #ececec;
    border-radius: 10px;
    padding: 12px;
    margin: 10px;
    background: #fff;
  }
  .row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 8px;
  }
  .k {
    color: #7a7a7a;
    font-size: 15px;
  }
  .v {
    color: #111;
    font-size: 15px;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .detail {
    max-width: 210px;
    white-space: normal;
    text-align: right;
    line-height: 18px;
  }
  .detail {
    max-width: 210px;
    white-space: normal;
    text-align: right;
    line-height: 18px;
  }
  .price {
    color: #ef4444;
    font-weight: 600;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
    padding-top: 2px;
  }
}
</style>

